import { Injectable } from "@angular/core";
import { Resposta } from "../models/resposta";
import { RespostaListaDinamica } from "../models/resposta.lista-dinamica.model";
import { Observable } from "rxjs";
import { ServiceUtil } from "../util/service.util";
import { HttpService } from "ems-oauth2-client";
import { RespostaQuestionarioService } from "./resposta-questionario.service";

/**
 * Classe deprecated, utilizar RespostaDinamicoService
 */
@Injectable()
export class RespostaListaDinamicaService extends ServiceUtil {
  private url = "/questionario/resposta";
  filtro: Resposta = new Resposta();
  // construtor
  constructor(private http: HttpService, private respostaService: RespostaQuestionarioService) {
    super();
  }

  /**
   * Método deprecated, utilizar métodos da classe RespostaDinamicoService
   * @param filtro 
   */
  filtrar(filtro: Resposta): Observable<RespostaListaDinamica> {
    return this.respostaService.filtrar(filtro);
   }

    /**
   * Método deprecated, utilizar métodos da classe RespostaDinamicoService
   * @param filtro 
   */
  filtrarPorListaResposta(listaRespostas: Resposta[], idQuestionario: number): Observable<RespostaListaDinamica> {
    return this.respostaService.filtrarPorListaResposta(listaRespostas, idQuestionario);
  }

  /**
   * Método deprecated, utilizar métodos da classe RespostaDinamicoService
   * @param filtro 
   */
  deletar(idResposta: number): Observable<Resposta> {
    return this.respostaService.deletar(idResposta);
  }

  /**
   * Método deprecated, utilizar métodos da classe RespostaDinamicoService
   * @param filtro 
   */
  getRespostaPorId(id: number): Observable<Resposta> {
    return this.respostaService.getRespostaPorId(id);
  }

    /**
   * Método deprecated, utilizar métodos da classe RespostaDinamicoService
   * @param filtro 
   */
  getRespostaPorIdCompleta(id: number): Observable<Resposta> {
    return this.respostaService.getRespostaPorIdCompleta(id);
  }

    /**
   * Método deprecated, utilizar métodos da classe RespostaDinamicoService
   * @param filtro 
   */
  getRespostaCompletaPorPergunta(id: number): Observable<Resposta> {
    return this.respostaService.getRespostaCompletaPorPergunta(id);
  }

    /**
   * Método deprecated, utilizar métodos da classe RespostaDinamicoService
   * @param filtro 
   */
  getRespostaCompletaPorQuestionario(id: number): Observable<Resposta[]> {
    return this.respostaService.getRespostaCompletaPorQuestionario(id);
  }

  /**
   * Método deprecated, utilizar métodos da classe RespostaDinamicoService
   * @param filtro 
   */
  getRespostaCompletaPorIdResposta(id: number): Observable<Resposta[]> {
    return this.respostaService.getRespostaCompletaPorIdResposta(id);
  }


   /**
   * Método deprecated, utilizar métodos da classe RespostaDinamicoService
   * @param filtro 
   */
  getRespostaCompletaPorQuestionarioFiltro(id: number): Observable<Resposta[]> {
    return this.respostaService.getRespostaCompletaPorQuestionarioFiltro(id);
  }

  /**
  * Método deprecated, utilizar métodos da classe RespostaDinamicoService
  * @param filtro 
  */
  getRespostaInicial(idQuestionario: number,  parametroInicializado: string): Observable<Resposta> {
    return this.respostaService.getRespostaInicial(idQuestionario, parametroInicializado);
  }

  /**
   * Método deprecated, utilizar métodos da classe RespostaDinamicoService
   * @param filtro 
   */
  getRespostaPorNomeUnico(idResposta: number, nomePergunta: string): Observable<String> {
    return this.respostaService.getRespostaPorNomeUnico(idResposta, nomePergunta);
  }
}